export const MaxNoteNumber = 127
